<div class="add-patient-wrapper">
  <form class="add-patient-form" [formGroup]="form">
    <div class="gender">
      <label class="gender-title">{{ 'general.gender' | translate }}</label>
      <div class="gender-content">
        <div class="gender-content-item" *ngFor="let gender of genderList">
          <p-radiobutton [value]="gender.key" formControlName="gender" [inputId]="'gender_' + gender.key" />
          <label class="cursor-pointer" [for]="'gender_' + gender.key">
            {{ gender.title | translate }}
          </label>
        </div>
      </div>
    </div>

    <p-floatlabel variant="in">
      <input pInputText formControlName="firstName" />
      <label>{{ 'general.firstName' | translate }}</label>
    </p-floatlabel>

    <p-floatlabel variant="in">
      <input pInputText formControlName="lastName" />
      <label>{{ 'general.lastName' | translate }}</label>
    </p-floatlabel>

    <p-floatlabel variant="in" *ngIf="showDateOfBirth">
      <p-datepicker
        formControlName="dateOfBirth"
        showIcon
        [maxDate]="currentDate"
        iconDisplay="input"
        appendTo="body"
        [monthNavigator]="true"
        [yearNavigator]="true"
        [yearRange]="yearRange"
      />
      <label>{{ 'general.dateOfBirth' | translate }} {{ 'general.optionalTips' | translate }}</label>
    </p-floatlabel>

    <div *ngIf="showMomentDirect" class="moment-direct">
      <span *ngIf="lockMomentDirect; else editableMomentDirect" class="moment-direct__locked-check">
        <span class="pi pi-check"></span>
      </span>
      <ng-template #editableMomentDirect>
        <p-checkbox formControlName="isMomentDirect" [binary]="true" inputId="isMomentDirect" />
      </ng-template>
      <label for="isMomentDirect">{{ 'general.momentDirectPatient' | translate }}</label>
    </div>

    <p-floatlabel variant="in" class="merge-columns">
      <input pInputText formControlName="notes" />
      <label>{{ 'general.notes' | translate }} {{ 'general.optionalTips' | translate }}</label>
    </p-floatlabel>

    <wl-patient-files-upload
      *ngIf="isMomentDirect"
      class="merge-columns"
      [initialFiles]="patientFiles"
      (stateChanged)="onPatientFilesChanged($event)"
    />
  </form>

  <p-toast position="bottom-right" />
</div>
